import classNames from "classnames";
import IconSVG from "../../../styles/svg-icons";
import { GridColumn } from "../../../types/state/GridState";
import { BlockedFeatureTooltipText } from "../../access/BlockedFeatureText";
import { OnHoverTooltip } from "../../common";

interface Props {
    column: GridColumn;
}

export const BlockedCell = ({ column }: Props) => {
    const cellClassName = classNames(column.className, {
        [`cell-${column.name}`]: true,
        readonly: true,
    });

    return (
        <td className={cellClassName}>
            <div className="cell-item">
                <OnHoverTooltip
                    overlay={<BlockedFeatureTooltipText />}
                    overlayClassName="trial-tooltip"
                >
                    <IconSVG
                        width="16"
                        height="16"
                        name="subscribe-lock-grey"
                    />
                </OnHoverTooltip>
            </div>
        </td>
    );
};
